import React from 'react';
import { Link } from 'react-router-dom';
import './Products.css';
import useReveal from '../hooks/useReveal';
import TokenRevealText from '../components/TokenRevealText';
import solutions from '../data/solutions';

const Products = () => {
  useReveal();
  const getCandidates = (solutionId) => {
    const match = solutions.find((item) => item.id === solutionId);
    return match?.imageCandidates || [];
  };

  return (
    <main className="products-page page-enter">
      {/* Page Hero */}
      <section className="page-hero">
        <div className="container reveal">
          <p className="section-eyebrow-light">
            <TokenRevealText text="Engineering Solutions – From Concept to Product" speed="medium" />
          </p>
          <h1><TokenRevealText text="Engineering Solutions – From Concept to Product" speed="medium" /></h1>
          <p>
            <TokenRevealText
              text="We deliver integrated mechanical solutions tailored to real-world applications – from enclosures and thermal systems to connectivity and precision tooling. Designed, engineered, and manufactured for performance, reliability, and scale."
              speed="medium"
            />
          </p>
        </div>
      </section>

      {/* ===== SOLUTIONS GRID ===== */}
      <section className="section">
        <div className="container">
          <div className="reveal" style={{ textAlign: 'center', maxWidth: '720px', margin: '0 auto 56px' }}>
            <p className="section-eyebrow"><TokenRevealText text="Solutions" speed="medium" /></p>
            <h2 className="section-title centered">
              <TokenRevealText text="Industry-Focused Solutions" speed="medium" />
            </h2>
            <div className="divider" style={{ margin: '12px auto 20px' }} />
            <p className="section-subtitle" style={{ margin: '0 auto' }}>
              <TokenRevealText
                text="We solve for product performance, manufacturability, and scale with tailored engineering and production capabilities."
                speed="medium"
              />
            </p>
          </div>

          <div className="products-grid">
            {solutions.map((p, i) => (
              <Link
                key={p.id}
                id={p.id}
                to={`/solutions/${p.id}`}
                className={`product-card reveal reveal-scale reveal-d${(i % 3) + 1}`}
                aria-label={`${p.title} details`}
              >
                <div
                  className="product-img"
                  style={{ overflow: 'hidden', borderRadius: '8px' }}
                >
                  {(() => {
                    const candidates = getCandidates(p.id);
                    const placeholder = '/images/C2P.jpg';
                    const src = candidates[0] || placeholder;

                    return (
                  <img
                    src={src}
                    alt={p.title}
                    style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                    onError={(e) => {
                      const img = e.currentTarget;
                      const currentIndex = Number(img.dataset.candidateIndex || '0');

                      if (candidates.length > 0 && currentIndex < candidates.length - 1) {
                        img.dataset.candidateIndex = String(currentIndex + 1);
                        img.src = candidates[currentIndex + 1];
                        return;
                      }

                      img.onerror = null;
                      img.src = placeholder;
                    }}
                    data-candidate-index="0"
                  />
                    );
                  })()}
                </div>
                <div className="product-body">
                  <h3><TokenRevealText text={p.title} speed="medium" /></h3>
                  <p className="product-desc"><TokenRevealText text={p.desc} speed="medium" /></p>
                  <div className="product-actions">
                    <div className="product-tags">
                      {p.tags.map((tag) => (
                        <span key={tag} className="product-tag"><TokenRevealText text={tag} speed="medium" /></span>
                      ))}
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* ===== CTA ===== */}
      <section className="products-cta">
        <div className="container products-cta-inner">
          <h2><TokenRevealText text="Need a custom component?" speed="medium" /></h2>
          <p><TokenRevealText text="Tell us your requirements and we will engineer the right solution." speed="medium" /></p>
          <Link to="/contact" className="btn-primary">
            <TokenRevealText text="Let's Connect" speed="medium" />
          </Link>
        </div>
      </section>
    </main>
  );
};

export default Products;